
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ComplainsModel } from '../models/ComplainsModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class ComplainsService {
  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
  }

public getComplainsLookupTop() {
    return this.http.get<ComplainsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Compalins/CompalinsLookupTop');
}

public getComplainsLookup(thname: string,) {
  let params = new HttpParams();
      params = params.append("ThName", thname);
    const options = {
          params: params
      };
  return this.http.get<ComplainsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Compalins/CompalinsLookup', options);
}
}
